export enum ImageEnum
{
    ImageProfile = 1,
    ImagePassport = 2,
}